var _circle, _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    transform: "rotate(-90 16 16)",
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6021 14.3929L21.2839 14.0787C21.073 13.8704 20.7311 13.8704 20.5202 14.0787L16.7652 17.8088L16.7652 8.2138C16.7652 7.91927 16.5234 7.68047 16.2252 7.68047L15.7752 7.68047C15.477 7.68047 15.2352 7.91927 15.2352 8.2138L15.2352 17.8088L11.4802 14.0787C11.2694 13.8704 10.9275 13.8704 10.7165 14.0787L10.3984 14.3929C10.1875 14.6012 10.1875 14.9389 10.3984 15.1472L15.6184 20.3243C15.8293 20.5325 16.1712 20.5325 16.3821 20.3243L21.6021 15.1472C21.813 14.9389 21.813 14.6012 21.6021 14.3929Z",
    fill: "#1752AF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.96094,
    y: 21.7598,
    width: 14.08,
    height: 1.536,
    rx: 0.4,
    fill: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.fdf0a3665a73d9b801c5ee2fd4489bbe.svg";
export { ForwardRef as ReactComponent };